import _defineProperty from "D:/ZhuoMian/tianxiawang/txw-service/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import store from "@/store";
import { Cmd, ImGroupCmd } from "@/utils/websocket/Cmd";
import { findSessionById, findSessionList, loginChat } from "../http/chat/chat";
import { initMessage } from "./WebsocketUtil";
import { getUuidV4 } from "@/utils/utils";
class WebSocketManager {
  constructor() {
    _defineProperty(this, "ws", null);
    _defineProperty(this, "url", null);
    _defineProperty(this, "protocols", void 0);
    _defineProperty(this, "reconnectInterval", void 0);
    _defineProperty(this, "maxReconnectAttempts", void 0);
    _defineProperty(this, "lockReconnect", false);
    _defineProperty(this, "reconnectAttempts", 0);
    _defineProperty(this, "reconnectTimer", null);
    _defineProperty(this, "heartbeatTimer", null);
    _defineProperty(this, "heartbeatInterval", void 0);
    _defineProperty(this, "heartbeatMessage", void 0);
    _defineProperty(this, "eventHandlers", new Map());
    _defineProperty(this, "readyState", ref(WebSocket.CLOSED));
    _defineProperty(this, "device", getUuidV4());
    this.reconnectInterval = 3000;
    this.maxReconnectAttempts = 30;
    this.heartbeatInterval = 20000;
    this.heartbeatMessage = {
      cmd: Cmd.PING
    };
  }
  static getInstance() {
    if (!this.instance) {
      this.instance = new WebSocketManager();
    }
    return this.instance;
  }
  setConfig(config) {
    this.url = process.env.VUE_APP_SOCKET_URL;
    this.protocols = config.protocols;
    this.reconnectInterval = config.reconnectInterval || 3000;
    this.maxReconnectAttempts = config.maxReconnectAttempts || 30;
    this.heartbeatInterval = config.heartbeatInterval || 20000;
    this.heartbeatMessage = config.heartbeatMessage || {
      cmd: Cmd.PING
    };
  }
  // 连接WebSocket
  connect() {
    try {
      if (this.readyState.value == WebSocket.OPEN || this.readyState.value == WebSocket.CONNECTING) return;
      if (!this.url) {
        this.log("请配置通讯地址");
        return;
      }
      let time = store.state.chatToken.expire_time || 0;
      let sign = store.state.chatToken.access_token;
      if (!sign || time - 30 * 60 * 1000 < new Date().getTime()) {
        this.loginIm().then(res => {
          this.readyState.value = res ? WebSocket.CONNECTING : WebSocket.CLOSED;
        });
        return;
      }
      this.readyState.value = WebSocket.CONNECTING;
      this.log("通讯系统连接中 WebSocket connecting ......");
      let url = `${this.url}?sign=${sign}&device=${this.device}`;
      this.ws = this.protocols ? new WebSocket(url, this.protocols) : new WebSocket(url);
      this.initEventHandlers();
    } catch (error) {
      this.readyState.value = WebSocket.CLOSED;
      this.log("连接失败 WebSocket connection error:" + error);
    }
  }
  // 初始化事件处理器
  initEventHandlers() {
    if (!this.ws) return;
    this.ws.onopen = event => {
      this.log("连接成功 WebSocket connected");
      this.reconnectAttempts = 0;
      this.readyState.value = WebSocket.OPEN;
      this.getSessionList();
      this.emit('open', event);
      this.startHeartbeat();
    };
    this.ws.onmessage = event => this.onMessage(event);
    this.ws.onclose = event => {
      this.log("连接已断开 WebSocket connect closed:" + event.code + event.reason);
      this.readyState.value = WebSocket.CLOSED;
      this.lockReconnect = false;
      this.emit('close', event);
      this.reconnect();
    };
    this.ws.onerror = error => {
      this.log("连接出现异常 WebSocket error:" + error);
      this.readyState.value = WebSocket.CLOSED;
      this.emit('error', error);
    };
  }
  // 重连
  reconnect() {
    if (this.lockReconnect) return;
    if (this.reconnectAttempts >= this.maxReconnectAttempts) {
      this.close();
      return;
    }
    this.stopHeartbeat();
    this.lockReconnect = true;
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
    }
    this.reconnectTimer = window.setTimeout(() => {
      this.reconnectAttempts++;
      let msg = "连接已断开," + this.reconnectInterval / 1000 + "秒后进行第" + (this.reconnectAttempts + 1) + "次重连...... connection is reconnecting";
      this.log(msg);
      this.connect();
    }, this.reconnectInterval);
  }
  // 开始心跳
  startHeartbeat() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
    }
    this.stopHeartbeat();
    this.heartbeatTimer = window.setInterval(() => {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.send(this.heartbeatMessage);
        this.log("ping heartbeat request");
      }
    }, this.heartbeatInterval);
  }
  // 停止心跳
  stopHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer);
      this.heartbeatTimer = null;
    }
  }
  async loginIm() {
    if (store.state.userInfo != null) {
      let from = {
        memberId: store.state.userInfo.id,
        sign: store.state.token.access_token
      };
      const res = await loginChat(from);
      if (res.status != 200) {
        this.log("通讯系统登录失败 the login fail");
        return false;
      }
      this.log("通讯系统登录成功 the login success");
      store.commit("LOGIN_CHAT", res.data);
      this.connect();
      return true;
    }
    return false;
  }
  async getSessionList() {
    let from = {
      lastTime: store.state.sessionData.last_time
    };
    const res = await findSessionList(from);
    if (res.status != 200) return false;
    store.commit("sessionData", res.data);
    return true;
  }
  async getSessionById(sessionId) {
    let res = await findSessionById(sessionId);
    if (res.status != 200) return false;
    let status = false;
    let arr = [];
    const sessionData = store.state.sessionData.data || [];
    for (let i = 0; i < sessionData.length; i++) {
      if (sessionData[i].sessionInfo.sessionId == sessionId && res.data) {
        sessionData[i] = res.data;
        status = true;
      }
      arr.push(sessionData[i]);
    }
    if (!status) arr.push(res.data);
    arr.sort((a, b) => {
      return b.sessionInfo?.lastMsgTime - a.sessionInfo?.lastMsgTime;
    });
    store.commit("sessionData", arr);
    return true;
  }
  log(msg) {
    console.log("[%cCHAT-INFO%c]:" + msg, 'color: green', 'color: baclk');
  }
  // 关闭连接
  close() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
    this.stopHeartbeat();
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
    this.lockReconnect = false;
    this.reconnectAttempts = 0;
    this.readyState.value = WebSocket.CLOSED;
    this.log("连接已关闭 the connection has been closed");
  }
  onMessage(event) {
    try {
      const data = JSON.parse(event.data);
      if (data.cmd === Cmd.PONG) {
        this.log("pong heartbeat response");
        return;
      } else {
        if (data.cmd == Cmd.MESSAGE) {
          this.getSessionById(data.message.sessionId);
        } else if (data.cmd == Cmd.GROUP_CHANGE) {
          this.onGroupChangeMessage(data.customData);
        } else if (data.cmd == Cmd.CONNECT_EXECUTE) {
          this.log(data.customData.message);
        } else if (data.cmd == Cmd.USER_INFO_CHANGE) {
          this.getSessionList();
        } else if (data.cmd == Cmd.USER_ONLINE) {
          this.handleOnline(data.customData?.id, true);
        } else if (data.cmd == Cmd.USER_OFFLINE) {
          this.handleOnline(data.customData?.id, false);
        }
        this.emit('message', data);
      }
    } catch (error) {
      this.log("解析失败 parse message error:" + error);
    }
  }
  onGroupChangeMessage(data) {
    if (data.code == ImGroupCmd.UPDATE_INFO) {
      this.getSessionById(data.sessionId);
    } else if (data.code == ImGroupCmd.DISBAND_GROUP) {
      this.getSessionList();
    } else if (data.code == ImGroupCmd.USER_MUTE) {
      this.getSessionById(data.sessionId);
    } else if (data.code == ImGroupCmd.USER_ROLE_AUTH) {
      this.getSessionById(data.sessionId);
    } else if (data.code == ImGroupCmd.REMOVE_USER) {
      this.getSessionList();
    }
  }
  handleOnline(userId, status) {
    let arr = [];
    const sessionData = store.state.sessionData.data || [];
    for (let i = 0; i < sessionData.length; i++) {
      if (sessionData[i].sessionInfo.sessionType == 1 && sessionData[i].contactUser.userId == userId) {
        sessionData[i].contactUser.online = status;
      }
      arr.push(sessionData[i]);
    }
    arr.sort((a, b) => {
      return b.sessionInfo?.lastMsgTime - a.sessionInfo?.lastMsgTime;
    });
    store.commit("sessionData", arr);
    return true;
  }
  emit(event, ...args) {
    const handlers = this.eventHandlers.get(event);
    handlers?.forEach(cb => cb(...args));
  }
  on(event, callback) {
    if (!this.eventHandlers.has(event)) {
      this.eventHandlers.set(event, new Set());
    }
    this.eventHandlers.get(event).add(callback);
  }
  off(event, callback) {
    this.eventHandlers.get(event)?.delete(callback);
  }
  sendRead(sessionId, time) {
    if (!time) time = new Date().getTime();
    let customData = {
      sessionId: sessionId,
      time: time
    };
    let messageData = {
      cmd: Cmd.READ,
      customData: customData
    };
    return this.send(messageData);
  }
  sendCmdMessage(cmd, msgType, sessionId, data, time) {
    let message = initMessage(msgType, sessionId, data, time);
    if (message == null) return false;
    let messageData = {
      cmd: cmd,
      message: message
    };
    return this.send(messageData);
  }
  sendMessage(msgType, sessionId, data, time) {
    let message = initMessage(msgType, sessionId, data, time);
    if (message == null) return false;
    let messageData = {
      cmd: Cmd.MESSAGE,
      message: message
    };
    return this.send(messageData);
  }
  sendImMessage(message) {
    let messageData = {
      cmd: Cmd.MESSAGE,
      message: message
    };
    return this.send(messageData);
  }
  // 发送消息
  send(data) {
    try {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(JSON.stringify(data));
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }
}
_defineProperty(WebSocketManager, "instance", null);
export default WebSocketManager.getInstance();